import React from 'react';

function Buscador({ termino, setTermino, productos, agregarAlCarro }) {
    
    // Función que captura cuando el lector de código de barras presiona "Enter"
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const textoEscaneado = (termino || '').trim();
            if (!textoEscaneado) return;

            // Buscamos si hay una coincidencia exacta con el código de barras o SKU.
            // OJO: Cambia "codigo_barras" por el nombre real de tu columna en la BD (ej. "codigo", "sku", "barcode")
            // Buscamos si hay una coincidencia exacta
            const productoEncontrado = productos.find(p => String(p.codigo_barras) === textoEscaneado);
            if (productoEncontrado) {
                // 1. Lo agregamos al carro directamente
                agregarAlCarro(productoEncontrado);
                // 2. Limpiamos el input para que esté listo para el siguiente "bip" del lector
                setTermino('');
            }
        }
    };

    return (
        <div className="input-group input-group-lg shadow-sm bg-white" style={{ borderRadius: '30px', overflow: 'hidden', border: '1px solid #ced4da' }}>
            <div className="input-group-prepend">
                <span className="input-group-text bg-white border-0 text-muted px-4">
                    <i className="fas fa-search text-primary"></i>
                </span>
            </div>
            
            <input
                type="text"
                className="form-control border-0 shadow-none font-weight-bold"
                placeholder="Buscar nombre o escanear código..."
                value={termino || ''}
                onChange={(e) => setTermino(e.target.value)}
                onKeyDown={handleKeyDown}
                autoFocus
                style={{ fontSize: '1.1rem', backgroundColor: 'transparent' }}
            />
            
            {/* Botoncito (X) para limpiar rápidamente la búsqueda si escribiste mal */}
            {termino && (
                <div className="input-group-append">
                    <button className="btn btn-white border-0 text-muted pr-4 shadow-none" onClick={() => setTermino('')}>
                        <i className="fas fa-times-circle text-danger"></i>
                    </button>
                </div>
            )}
        </div>
    );
}

export default Buscador;